(() => {
  if (window.__nbWave2PdpCore) return;
  window.__nbWave2PdpCore = true;

  function moneyFromDom() {
    const price =
      document.querySelector('.price__regular .price-item--regular, .price-item--sale, .price .price-item') ||
      document.querySelector('[data-product-price], .product__price');
    return (price && price.textContent || '').replace(/\s+/g, ' ').trim();
  }
  function variantLabel() {
    const checked = document.querySelector('.product-form__input input[type=radio]:checked + label, fieldset input[type=radio]:checked');
    if (checked && checked.value) return checked.value;
    const lab = document.querySelector('.product-form__input input[type=radio]:checked + label');
    return (lab && lab.textContent || '').replace(/\s+/g, ' ').trim() || '';
  }
  function syncSummary() {
    const titleEl = document.querySelector('.product__title, h1.product__title, .product .h1');
    const title = (titleEl && titleEl.textContent || '').replace(/\s+/g, ' ').trim();
    const price = moneyFromDom();
    const variant = variantLabel();
    const sum = document.getElementById('nbWave2Summary');
    if (!sum) return;
    const t = sum.querySelector('[data-nb-sum-title]');
    const p = sum.querySelector('[data-nb-sum-price]');
    const v = sum.querySelector('[data-nb-sum-variant]');
    const d = sum.querySelector('[data-nb-sum-dest]');
    if (t) t.textContent = title;
    if (p) p.textContent = price;
    if (v) v.textContent = variant ? variant : '';
    if (d) {
      const host = (location.hostname || '').toLowerCase();
      if (host.includes('northblomst.com')) d.textContent = 'Delivery to verified markets';
      else if (location.pathname.indexOf('/en') === 0) d.textContent = 'Send flowers to Denmark';
      else d.textContent = 'Levering i Danmark';
    }
    window.__nbWave2LastPrice = price;
    window.__nbWave2LastVariant = variant || title;
  }

  function boot() {
    syncSummary();
    document.addEventListener('change', syncSummary, true);
    document.addEventListener('input', syncSummary, true);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
